interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "center" }: SectionHeadingProps) {
  return (
    <div className={`mb-10 md:mb-14 ${align === "center" ? "text-center mx-auto" : "text-left"}`}>
      <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : "justify-start"}`}>
        <span className="h-px w-8 bg-primary-500" />
        <span className="text-sm tracking-widest text-primary-500 uppercase">{eyebrow}</span>
        <span className="h-px w-8 bg-primary-500" />
      </div>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl">{desc}</p>}
    </div>
  );
}